<template>
    <div class="patient">
        
      <p @click="router.go(-1)" style="margin: 0;"><el-icon><ArrowLeftBold /></el-icon></p> 
      <p class="title">{{ report }}</p>
        <div >
        </div>
        <p>实验室检查报告</p>
        
        <div class="items">
          <template v-for="(items, i) in datas">
            <div  :key="i" v-if="module.includes(items.type)" class="item">
                <div class="title">{{ items.name }}</div>
                <div class="imgs">
                    <el-icon class="avatar-uploader-icon" @click="uploaddata(items.key)"><Plus /></el-icon>
                    <div class="img" v-for="(item, index) in arr_obj(items.value)" :key="index" > 
                        <img :src="item?.url"  alt="" @click="imgdialog = item.url">
                        <!-- 删除 -->
                        <span class="icon" @click="handleRemove( items.key,item.name,index)">
                            <!-- <el-icon ><Delete /></el-icon> -->
                             ×
                        </span>
                    </div>
                </div>
            </div>
          </template>
        </div> 
    </div>
    <el-upload v-if="uploadshow" style="display:none"
        ref="uploadRef"
        action="#"
        :show-file-list="false"
        :auto-upload="false" 
        :on-change="uploadFile"
      >
    </el-upload>
    <!-- 图片放大 -->
     <div class="imgdialog" v-if="imgdialog">
        <div class="boximg">
          <span class="icon" @click="imgdialog = ''">×</span>
          <img :src="imgdialog" alt=""/>
        </div>
     </div>
</template>
<script setup>
import { ref , onMounted} from 'vue'
import { usePatientStore } from "@/stores/patient";
import { useCrfStore } from "@/stores/crf";
import { useCommonStore } from "@/stores/common.js";
import { useUserStore } from "@/stores/user";
import { ElMessage, ElMessageBox } from 'element-plus'
import  axios from "axios"
import { useRouter, useRoute} from 'vue-router';
// const router = useRouter();
const userStore = useUserStore();
let progressFlog = ref(false)
let loadProgress = ref(0)

const router = useRouter();
const route = useRoute();

const imgdialog = ref('')
//存标题
const datas = ref([])

//患者id
const patientId = ref('');
// 操作的访视期
const report = ref('');

const api_host = import.meta.env.VITE_APP_API_HOST;
//计划外访视期
const jhwmodule =  ["YBXX", "FSXX",  "XCGJNCG","HVPGCD","MYQDB", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","AFP","NXGN", "MJMCTV", "XSHJC","FIBROSCAN","FIBROTOUCH", "XDT","WJ", "FBFSMJMBC","BLSJJL" ,"MRCP","GZZQMR","FBCT","GZZQCT",]
//保存选择访视期的合集
const module = ref([]);
const forms = [
      {
        name: "筛选期（肝穿前96周内资料完整点）±2周",
        type: "筛选期（肝穿前96周内资料完整点）±2周",
        module: ["YBXX", "FSXX", "BS", "QTBSZL", "JWTIPSZL", "JWWKSSZL","MYQDB", "JWNJZL", "JWYWZL","GZSDC", "YJQJDYWZL", "YJQJDTIPSZL", "YJQJDNJZL", "YJQJDWKZL", "XCGJNCG", "NXGN", "FBCT","XSHJC", "AFP", "YGHCVHIV", "ANAANCA", "JZXGN", "XDT", "WJ", "FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "MJMCTV", "GZZQCT","GZZQMR", "MRCP", "HVPGCD",]
      },
      {//0
        name: "V0肝穿点±2周",
        type: "V0肝穿点±2周",
        module: ["YBXX", "FSXX", "TGJC", "QTBSZL","BS", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","GZSDC", "YJQJDYWZL", "YJQJDTIPSZL", "YJQJDNJZL", "YJQJDWKZL", "XCGJNCG", "NXGN", "XSHJC","MRCP", "AFP", "YGHCVHIV", "ANAANCA", "JZXGN","MYQDB","XDT", "WJ", "FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "HVPGCD", "FBCT","MJMCTV", "GZZQMR","QWXZJYCX", "GZZQCT","BFXY","BLBG"],
        moduleOld: ["YBXX", "FSXX", "TGJC", "QTBSZL","BS", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","GZSDC", "YJQJDYWZL", "YJQJDTIPSZL", "YJQJDNJZL", "YJQJDWKZL", "XCGJNCG", "NXGN", "XSHJC","MRCP", "AFP", "YGHCVHIV", "ANAANCA", "JZXGN","MYQDB","XDT", "WJ", "FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "HVPGCD", "FBCT","MJMCTV", "GZZQMR","QWXZJYCX", "GZZQCT","BFXY","BLBG"]
      },
      {//1
        name: "访视期V1（肝穿后24周）",
        type: "访视期V1（肝穿后24周）",
        tip:24,
        module: ["YBXX", "FSXX",  "XCGJNCG","HVPGCD", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","AFP","NXGN", "MJMCTV", "XSHJC","FIBROSCAN","FIBROTOUCH", "XDT","WJ", "FBFSMJMBC","BLSJJL" ,"MRCP","GZZQMR","FBCT","GZZQCT","MYQDB",]
      },
       {//2
        name: "访视期V2（肝穿后48周）",
        type: "访视期V2（肝穿后48周）",
        tip:48,
        module: ["YBXX", "FSXX",  "ANAANCA","MYQDB", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","YGHCVHIV", "TGJC","XDT", "WJ","HVPGCD", "FBFSMJMBC","AFP", "XCGJNCG", "MRCP","MJMCTV", "NXGN","FIBROSCAN","FIBROTOUCH",  "FBCT","XSHJC","GZZQMR","BLSJJL","GZZQCT",]
      },
      {//3
        name: "访视期V3（肝穿后72周）",
        type: "访视期V3（肝穿后72周）",
        tip:72,
        module: ["YBXX", "FSXX", "XCGJNCG", "MYQDB","NXGN","BS", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","XSHJC", "AFP","XDT","WJ","HVPGCD","MJMCTV","FIBROSCAN","FIBROTOUCH", "MRCP","FBFSMJMBC", "GZZQMR", "FBCT","BLSJJL","GZZQCT",]
      },
       {//4
        name: "访视期V4（肝穿后96周）",
        type: "访视期V4（肝穿后96周）",
        tip:96,
        module: ["YBXX", "FSXX", "TGJC","XCGJNCG","BS","MYQDB","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","YGHCVHIV","XDT", "WJ", "HVPGCD","ANAANCA", "NXGN", "XSHJC", "MRCP", "MJMCTV","AFP", "FBCT", "FIBROSCAN","FIBROTOUCH", "FBFSMJMBC","GZZQMR", "BLSJJL","GZZQCT",]
      },
      {//5
        name: "访视期V5（肝穿后120周）",
        type: "访视期V5（肝穿后120周）",
        tip:120,
        module: ["YBXX", "FSXX",  "XCGJNCG","MYQDB", "NXGN","BS", "XSHJC","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","XDT", "WJ","AFP","HVPGCD","MJMCTV", "FIBROSCAN","FIBROTOUCH","MRCP", "GZZQMR","FBFSMJMBC",  "FBCT","BLSJJL","GZZQCT",]
      },
      {//6
        name: "访视期V6（肝穿后144周）",
        type: "访视期V6（肝穿后144周）",
        tip:144,
        module: ["YBXX", "FSXX", "TGJC", "XCGJNCG","MYQDB","BS", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","YGHCVHIV", "NXGN", "MJMCTV", "XSHJC","HVPGCD","AFP", "ANAANCA","XDT","WJ", "MRCP","FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "FBCT","GZZQMR", "BLSJJL","GZZQCT",]
      },
      {//7
        name: "访视期V7（肝穿后168周）",
        type: "访视期V7（肝穿后168周）",
        tip:168,
        module: ["YBXX", "FSXX", "XCGJNCG","MYQDB", "XDT", "WJ", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","AFP","NXGN", "XSHJC", "MJMCTV", "HVPGCD","FIBROSCAN","FIBROTOUCH","GZZQMR","MRCP", "FBFSMJMBC", "FBCT", "BLSJJL","GZZQCT",]
      },
       {//8
        name: "访视期V8（肝穿后192周）",
        type: "访视期V8（肝穿后192周）",
        tip:192,
        module: ["YBXX", "FSXX","TGJC", "AFP", "XCGJNCG","BS","MYQDB", "JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL","YGHCVHIV","NXGN", "XDT", "HVPGCD","WJ", "ANAANCA","XSHJC", "MRCP", "MJMCTV","FIBROSCAN","FIBROTOUCH", "GZZQMR","FBFSMJMBC", "FBCT","BLSJJL","GZZQCT",]
      },
      {//9
        name: "访视期V9（肝穿后216周）",
        type: "访视期V9（肝穿后216周）",
        tip:216,
        module: ["YBXX", "FSXX", "XCGJNCG","MYQDB", "NXGN", "XSHJC","BS", "XDT","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL", "WJ","AFP", "MJMCTV","HVPGCD","FIBROSCAN","FIBROTOUCH", "MRCP","GZZQMR","FBFSMJMBC",  "FBCT","BLSJJL","GZZQCT",]
      },
       {//10
        name: "访视期V10（肝穿后240周）",
        type: "访视期V10（肝穿后240周）",
        tip:240,
        module: ["YBXX", "FSXX","TGJC", "XCGJNCG", "NXGN","MYQDB", "BS","JWTIPSZL", "JWWKSSZL", "JWNJZL", "JWYWZL", "YGHCVHIV", "XSHJC", "HVPGCD","AFP", "ANAANCA", "XDT", "WJ", "MRCP","FIBROSCAN","FIBROTOUCH", "FBFSMJMBC", "FBCT", "MJMCTV", "GZZQMR", "BLSJJL","GZZQCT",]
      },
    
    ]
//图片字段的处理
const items = [
    { name: '血常规', key:'xcgjncgimagesArray',type:'XCGJNCG' },
    { name: '凝血功能', key:'nxgnimagesArray', type:'NXGN' },
    { name: '血生化检查', key:'xshjcimagesArray', type:'XSHJC' },
    { name: 'AFP', key:'afpimagesArray', type:'AFP' },
    { name: '乙肝两对半检查、抗HCV、抗HIV', key:'yghcvhivimagesArray', type:'YGHCVHIV' },
    { name: '自身抗体谱', key:'anaancaimagesArray', type:'ANAANCA' },
    { name: '免疫球蛋白[IgG,IgA,IgM,IgE,IgG4(可选)]', key:'myqdbimagesArray' ,type:'MYQDB' },
    { name: '甲状腺功能', key:'jzxgnimagesArray', type:'JZXGN' },
    { name: '心电图（可选）', key:'xdtimagesArray', type:'XDT' },
    { name: '胃镜', key:'wjimagesArray', type:'WJ' },
    { name: '腹部、腹水及门静脉B超', key:'fbfsjmjmbcimagesArray', type:'FBFSMJMBC' },
    { name: '肺部CT平扫', key:'fbctimagesArray', type:'FBCT' },
    { name: '门静脉CTV', key:'mjmctvimagesArray', type:'MJMCTV' },
    { name: '肝脏增强CT', key:'gzzqctimagesArray', type:'GZZQCT'},
    { name: '肝脏增强MR', key:'gzzqmrimagesArray' ,type:'GZZQMR'},
    { name: '基因测序（可选）', key:'qwxzjycximagesArray', type:'QWXZJYCX'},

];
const uploadshow = ref(true)
const uploadRef = ref(null);
const uploadname = ref('');
//点击选择文件
const uploaddata =(name)=>{
  console.log(name,'111')
  uploadname.value = name
  uploadRef.value?.$el.querySelector('input[type="file"]').click();
}
//获取选中的文件
const handleFileChange = (event) => {
  uploadshow.value = false
  setTimeout(() => {
      uploadshow.value = true
  }, 500);
  const file = event.raw;
  console.log(uploadname.value,file ,'uploadname.value')
  const fileobj = new FormData();
  fileobj.append('file', file);
  api.uploadFile(fileobj).then(res => {
    if(uploadname.value == 'detail') {
      formData[`${uploadname.value}`].push(res.data)
    }else{    
      formData[`${uploadname.value}`] = res.data;
    }
  })
};
// 上传图片
const uploadFile =async (file)=>{
    let formdata = new FormData()
    formdata.append('file',file.raw)
    formdata.append('id',patientId.value)
    formdata.append('path',`${report.value}.${uploadname.value}`)
    progressFlog.value = true

    const upload = async (formdata)=>{
      let uploadPercent = null
      const res = await axios({
        method: 'post',
        url: `${api_host}api/file/upload`,
        data: formdata,
        onUploadProgress: (progressEvent_1) => {
          // 计算上传进度百分比
          uploadPercent = Math.round((progressEvent_1.loaded * 100) / progressEvent_1.total)
          loadProgress.value = uploadPercent
        }
      })
      return res.data
    }
    // 返回的是一个promise对象
    let res = await upload(formdata)
    console.log(res,'上传图片')
    // return
    if(res.result == 'success'){
        // model.fields[`${props.type}`][`${props.name}imagesArray`]?.push(res.data.name)
        // 上传成功后的操作
        console.log('上传成功')
        // 保存到页面
        let i =  datas.value.findIndex((item) => item.key == uploadname.value)
        console.log(datas.value[i],'datas')
         datas.value[i]?.value ==null?datas.value[i].value = []:''
        // debugger
        let arr = [...datas.value?.[i]?.value,res.data.name]

        let obj = {
            user_id:userStore.id,
            field_id:patientId.value,
            path:report.value +'.' + uploadname.value,
            value:arr,
        }
        let upres = await useCommonStore().upreports(obj)
        console.log(upres,'上传图片')
        if(upres.result == 'success'){
            console.log('保存成功')
            datas.value[i].value = arr
        }

        progressFlog.value = false
        loadProgress.value =0
        uploadname.value = ''
    }else{
        ElMessage.error(res.msg)
    }
};

  //  删除图片
const handleRemove = (path,name,index)=>{
  // id=${id}&path=${path}&index=${index}
  console.log(path,name,index,'删除图片')
  // return
  ElMessageBox.confirm(
    '确定要删除此文件吗？',
    'Warning',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(async () => {
    // 上传成功后的操作
        console.log('上传成功')
        // 保存到页面
        let i =  datas.value.findIndex((item) => item.key == path)
        let arr = datas.value[i].value
        arr.splice(index,1)
        let obj = {
            user_id:userStore.id,
            field_id:patientId.value,
            path:report.value +'.' + path,
            value:arr,
        }
        let upres = await useCommonStore().upreports(obj)
        console.log(upres,'上传图片')
        if(upres.result == 'success'){
            console.log('保存成功')
            datas.value[i].value = arr
        }
      // }else{
      //     ElMessage.error(res.msg)
      // }




      let pic_del = await common.pic_del(e.name,model.id,`${props.type}.${props.name}imagesArray`,index)
      if (pic_del.result == 'success'){
        model.fields[`${props.type}`][`${props.name}imagesArray`]?.splice(index,1)
      } else{
        ElMessage.error('删除失败！')
      }
    })
};








onMounted(() => {
    patientId.value = route.query.id;
    report.value = route.query.report;
    if(route.query.report.includes('计划外')){
         module.value = jhwmodule
    }else{

      module.value = forms.find(e => e.name == route.query.report).module;
    }
    console.log(module.value,'模块')
    // debugger

    getdata()
})





const getdata = async() =>{
    let obj = {
        field_id:patientId.value,
        periods:items.map(item=>report.value +'.'+item.key)
    }

    let res = await useCommonStore().getreports(obj)
    // lists.value = res.data.report_data.map(item=>{
    //     return {
    //         key:item.key
    //     }
    // })
    res = processKeys(res.data.report_data)
    console.log(res,'res')
    datas.value = items.map(item=>{
        let obj = {}
        for (const key in res) {
            if (res.hasOwnProperty(key)) {
                // 只比较自身属性
                if(key == item.key){
                    obj = {...item,value:res[key]}
                    break;
                }
            }
        }
        return obj
    })
   
    console.log(datas.value,'获取数据')

}
const processKeys = (obj)=>{
  const newObj = {};
  
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      // 使用正则表达式匹配点后面的英文部分（允许包含下划线）
      const match = key.match(/\.([a-zA-Z_]+)$/);
      const newKey = match ? match[1] : key;
      
      // 将处理后的键名存入新对象
      newObj[newKey] = obj[key];
    }
  }
  
  return newObj;
}

// 处理图片拿到的数据
const arr_obj = (arr)=>{
  if(!arr) return []
  const images = []
  arr.forEach((item,index )=> {
    const obj = {}
      obj.name = item
      obj.url =  `${api_host}api/file/get?name=${item}`
      obj.download = `${api_host}api/file/get?name=${ item}&isZip=false`
      images.push(obj)
    // images.push({
    //   name: item,
    //   url: api_host + item,
    //   download: `${api_host}api/file/get?name=${item}&isZip=false`
    // })
  });
  console.log(images,'图片数据')
  return images
}



;
</script>
<style  scoped>
.patient{
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    .title{
        font-size: 24px;
        margin-bottom: 20px;
    
    }
    .items{
        .imgs{
            width: 100%;
            flex-wrap: wrap;
            display: flex;
            margin-bottom: 20px;
            .el-icon.avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                background-color:#edeff1 ;
                width: 100px;
                height: 100px;
                text-align: center;
                border: 1px dashed var(--el-border-color);
                border-radius: 6px;
                cursor: pointer;
                margin-right: 15px;
                margin-top: 15px;

            }
            .img{
                position: relative;
                img{
                    width: 100px;
                    height: 100px;
                    margin-right: 15px;
                    margin-top: 15px;
                }
                .icon{
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    top: 10px;
                    right: 10px;
                    background-color: #8c939d;
                    text-align: center;
                    line-height: 20px;
                    border-radius: 50%;
                    color: #fff;
                }
            }
            
             
        }
    }
}
.imgdialog{
  position: fixed;
  inset: 0;
  background-color: rgba(0,0,0,0.5);
   display: flex;
    justify-content: center;
    align-items: center;
  .boximg{
    position: relative;
    width: 70%;
      .icon{
        position: absolute;
        top: -40px;

        right: 0;
        color: #fff;
        font-size: 32px;
      }
      img{
        width: 100%;
        object-fit: contain;
        display: block;
      }

  }
}
</style>